<template>
  <div class="modal fade show d-block" tabindex="-1" role="dialog" aria-labelledby="modalTitle" aria-modal="true">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">

        <div class="modal-header">
          <h5 class="modal-title">Załączniki do zapytania ofertowego (Oferta)</h5>
          <button type="button" class="btn-close" @click="$emit('close')"></button>
        </div>

        <div class="modal-body">

          <div v-if="quoteRequests.files && quoteRequests.files.length">
            <ul class="list-group mb-4">
              <li v-for="file in quoteRequests.files" :key="file.id"
                  class="list-group-item d-flex justify-content-between align-items-center">
                <a :href="route('quoteRequests.files.show', {file:file.id})" target="_blank">
                  {{ file.original_name }}
                </a>
                <button v-if="canRemove && hasPermission('canEditQuoteRequests')" class="btn btn-sm btn-danger"
                        @click="deleteFile(file.id)">Usuń
                </button>
              </li>
            </ul>
          </div>
          <div v-else class="alert alert-warning">
            Brak załączników.
          </div>

          <form v-if="canAdd && hasPermission('canEditQuoteRequests')" @submit.prevent="uploadFile" class="mt-3">
            <div class="mb-3">
              <label for="file" class="form-label">Dodaj załącznik (max 100MB)</label>
              <input class="form-control" type="file" id="file" multiple @change="handleFileChange">
            </div>
            <button class="btn btn-primary" :disabled="!selectedFiles.length">Wyślij</button>
          </form>

        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="$emit('close')">Zamknij</button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {useForm} from '@inertiajs/vue3'
import {usePermission} from "@/composables/resources/js/composables/permissions.js";

const {hasPermission} = usePermission();

export default {
  props: {
    quoteRequests: Object,
    canAdd: {type: Boolean, default: true},
    canRemove: {type: Boolean, default: true},
  },

  emits: ['refresh', 'added-success', 'added-error', 'close'],

  beforeMount() {
    if (!this.quoteRequests)
      return;

    // przemapowanie
    if (this.quoteRequests.quote_requests_files) {
      this.quoteRequests.files = this.quoteRequests.quote_requests_files;
    }
  },

  data() {
   // console.log(this.quoteRequests);
    return {
      hasPermission,
      selectedFiles: [],
    }
  },


  methods: {
    handleFileChange(event) {
      this.selectedFiles = Array.from(event.target.files);
    },

    async uploadFile() {
      if (!this.selectedFiles.length || !this.quoteRequests?.id) return

      const formData = new FormData();
      this.selectedFiles.forEach(file => formData.append('files[]', file));

      try {
        const response = await axios.post(route('quoteRequests.files.store', {quoteRequest: this.quoteRequests.id}), formData, {
          headers: {'Content-Type': 'multipart/form-data'}
        });

        this.selectedFiles = [];
        this.reloadFiles();
        this.$emit('added-success', response.data.message || 'Dodano załączniki');
        this.$emit('refresh', true);

      } catch (error) {
        console.error(error);
        this.$emit('added-error', error.response?.data?.message || 'Błąd podczas dodawania plików');
      }
    },


    deleteFile(fileId) {
      if (!this.quoteRequests?.id || !fileId) return

      axios.delete(route('quoteRequests.files.destroy', {
        quoteRequest: this.quoteRequests.id,
        file: fileId
      }))
          .then(response => {
            this.reloadFiles();
            this.$emit('added-success', response.data.message || 'Załącznik został usunięty.');
            this.$emit('refresh', true);
          })
          .catch(error => {
            console.error(error);
            let msg = error.response?.data?.message || 'Błąd podczas usuwania pliku.';
            this.$emit('added-error', msg);
          });
    },

    reloadFiles() {
      axios.get(route('quoteRequests.files.index', {quoteRequest: this.quoteRequests.id}))
          .then(response => {
            this.quoteRequests.files = response.data.files
          })
          .catch(error => {
            console.error('Nie udało się załadować załączników:', error)
          })
    },
  }
}
</script>


<style scoped>
.modal.show {
  display: block;
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
